import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import { Task } from '../../../../types/task';
import { TaskItem } from './TaskItem';
import { useAtomValue } from 'jotai';
import { isTaskItemDraggingAtom } from '../../../../atoms/v3/taskAtoms';


interface DraggableTaskItemProps {
  task: Task;
  onToggle: (taskId: string, completed: boolean) => void;
  onClick: (taskId: string) => void;
  onProjectClick?: (projectId: string) => void;
  isFirst?: boolean;
  isLast?: boolean;
  hideProjectName?: boolean;
}

/**
 * 可拖拽的任务项组件
 * 包装TaskItem组件，使其可拖拽
 * 可以拖拽到不同的组中移动任务
 */
export const DraggableTaskItem: React.FC<DraggableTaskItemProps> = (props) => {
  const isTaskItemDragging = useAtomValue(isTaskItemDraggingAtom);

  // 检测是否为触摸设备 - 基于实际能力而非平台
  const isTouchDevice = 'ontouchstart' in window ||
                        navigator.maxTouchPoints > 0 ||
                        window.matchMedia('(pointer: coarse)').matches;

  // 使用dnd-kit的useDraggable钩子
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: `task-${props.task.id}`,
    data: {
      type: 'task-item',
      taskId: props.task.id,
      task: props.task
    }
  });

  // 计算拖拽样式
  const style = {
    transform: CSS.Translate.toString(transform),
    zIndex: isDragging ? 9999 : 'auto',
    cursor: isDragging ? 'grabbing' : (isTouchDevice ? 'default' : 'pointer'),
    opacity: isTaskItemDragging && !isDragging ? 0.5 : 1
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
      className={`touch-manipulation ${isTouchDevice ? 'select-none' : ''}`}
      title={isTouchDevice ? '长按拖拽移动任务' : '拖拽移动任务'}
    >
      <TaskItem {...props} />
    </div>
  );
};

// 使用 React.memo 包装组件，避免不必要的重新渲染
export default React.memo(DraggableTaskItem);
